import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { connectState } from '@examdojo/angular/util';
import { ColorSchemeService } from '@examdojo/browser/color-scheme';
import { IonHeader, IonToolbar } from '@ionic/angular/standalone';

@Component({
  selector: 'dojo-top-header',
  template: `
    <ion-header class="ion-header">
      <ion-toolbar class="!px-6">
        <div class="flex items-center justify-between py-4">
          <a [routerLink]="'/'" class="flex">
            @if (state.darkMode) {
              <img src="./assets/images/logo/logo-color-horizontal-dark.svg" alt="Exam dojo" />
            } @else {
              <img src="assets/images/logo/logo-color-horizontal.svg" alt="Exam dojo" />
            }
          </a>
          <ng-content></ng-content>
        </div>
      </ion-toolbar>
    </ion-header>
  `,
  styles: [
    `
      .ion-header {
        box-shadow: none;
        border: 0;

        ion-toolbar {
          --background: theme('colors.neutral.0');
          --padding-top: 0;
          --padding-bottom: 0;
          --border-width: 0;
        }
      }
    `,
  ],
  imports: [RouterLink, IonHeader, IonToolbar],
  host: { class: 'block bg-neutral-0' },
})
export class TopHeaderComponent {
  constructor(private readonly userColorSchemeService: ColorSchemeService) {}

  readonly state = connectState({
    darkMode: this.userColorSchemeService.hasDarkMode$,
  });
}
